import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import MyPATTabs from '../../../common/MyPATTabs';
import MyPATTab from '../../../common/MyPATTab';
import { Button, Card, CardContent, Grid, Typography, WithStyles, withStyles } from '@material-ui/core';

import GeneralSettings from './GeneralSettings';
import FAQ from './FAQ';
import SEO from './SEO';

import {
  storeGeneralSettings,
  storeFAQ,
  storeSEO,
  saveAdvancedSettings,
  getCourseDetails
} from '../../actions/courseManagementActions';
import {
  AdvancedSettingsInterface,
  GeneralSettings as GeneralSettingsInterface,
  FAQ as FAQInterface,
  SEO as SEOInterface,
} from '../../types/interfaces/AdvancedSettings';
import {
  getDefaultAdvancedSettings,
  getDefaultFAQ,
  getDefaultGeneralSettings,
  getDefaultSEO,
  getGeneralSetting
} from '../../helpers/helpers';
import { ActiveTabs } from '../../types/enums/ActiveTabs';
import DialogFooter from '../../../userManagement/common/DialogFooter';
import { courseStyles } from '../../styles';
import classNames from 'classnames';
import { withRouter } from "react-router";
import { BasicInfo } from '../../types/interfaces/BasicInfo';
import { FreeOrPaid } from '../../types/enums/FreeOrPaid';
import { contentManagementAction } from "../../reducers/contentMangementData";
import { TabVisited } from '../../types/interfaces/TabVisited';
import { LocalPrintshopOutlined } from '@material-ui/icons';



interface Props extends WithStyles<typeof courseStyles>{
  generalSettings: GeneralSettingsInterface;
  faq: FAQInterface;
  seo: SEOInterface;
  storeGeneralSettings: Function;
  storeFAQ: Function;
  storeSEO: Function;
  saveAdvancedSettings: Function;
  packageId: string;
  disableAdvanceSetting:boolean;
  match: any;
  getCourseDetails: Function;
  packageData: BasicInfo;
  isPreview: boolean;
  setAdvancedSettingsValid: Function;
  setAdvancedSettingsUntouched: Function;
  tabVisited: TabVisited;
  setTabVisited: Function;
  publishBtnClicked: boolean;
  setAdvancedSettingMandatoryFlag: Function;
  setGeneralSettingsMandatoryFlag: Function;
  setSeoMandatoryFlag: Function;
}

interface State {
  advancedSettings: AdvancedSettingsInterface;
  generalSettings: GeneralSettingsInterface;
  faq: FAQInterface;
  seo: SEOInterface;
  activeTab: ActiveTabs;
  packageId: string;
  disableFields:boolean;
  canActivateSaveButton: boolean;
  tabVisited: TabVisited;
  generalSettingsMandatoryFilled: boolean;
  seoMandatoryFilled: boolean;
}

// Advanced Settings 
class AdvancedSettings extends Component<Props, State> {
  mandatoryTabs:string[];
  constructor(props: Props) {
    super(props);
    this.mandatoryTabs = ['General Settings', 'SEO']
    this.state = {
      advancedSettings: {},
      generalSettings: getDefaultGeneralSettings(),
      faq: getDefaultFAQ(),
      seo: getDefaultSEO(),
      activeTab: ActiveTabs.generalSettings,
      packageId:'',
      disableFields:false,
      canActivateSaveButton: true,
      tabVisited: {
        generalSettings: true,
        faq: false,
        seo: false
      },
      generalSettingsMandatoryFilled:false,
      seoMandatoryFilled: false
    };
  }

  componentDidMount(){
    this.resetAdvancedSettings()
    this.setState({
      advancedSettings: {},
      generalSettings: getDefaultGeneralSettings(),
      faq: getDefaultFAQ(),
      seo: getDefaultSEO(),
      activeTab: ActiveTabs.generalSettings,
      packageId:'',
      disableFields:false,
      canActivateSaveButton: true,
      tabVisited: {
        generalSettings: true,
        faq: false,
        seo: false
      },
      generalSettingsMandatoryFilled:false,
      seoMandatoryFilled: false
    })

  
    if(this.props.disableAdvanceSetting){
      this.setState({
        disableFields:true
      })
    }
     const {
      match: {
        params: { id = "" },
      },
    } = this.props;

    this.props.getCourseDetails(id)

    this.setState({
      packageId: id
    })
    
    const { generalSettings, packageData, storeSEO, storeGeneralSettings, storeFAQ } = this.props;
    // this.handleGeneralSettings(generalSettings)
    if(packageData && !_.isEmpty(packageData) && packageData._id === id) {
      const faq = packageData.FAQ;
      const seo = packageData.metatags;

      storeGeneralSettings(getGeneralSetting(packageData));
      storeSEO({metatags: seo})

      if(faq && +faq.length !== 0) {
        storeFAQ({FAQ : faq})
      };
    }

    this.checkSeoMandatoryFields(this.state.seo);
    this.checkGeneralSettingsMandatoryFields(this.state.generalSettings);
    this.checkMandatoryFields();
    
  }


  // getGeneralSetting = (packageData:BasicInfo) => {
  //   return {
  //     availableForB2C: packageData.availableForB2C,
  //     availableForTestUsers: packageData.availableForTestUsers,
  //     sellsOutsideIndia: packageData && packageData.localeWisePrice && packageData.localeWisePrice.length > 1 ? true : false, // NOT RECEIVING FROM BACKEND, CHECK
  //     isPaid: packageData.isPaid ? FreeOrPaid.paid : FreeOrPaid.free,
  //     price: packageData.price,
  //     discount: packageData.discount,
  //     localeWisePrice: [{  // NOT RECEIVING FROM BACKEND, CHECK
  //         locale: 'IN',
  //         price: 1,
  //         discount: 0
  //     }],
  //     otherInfo: packageData.otherInfo
  // }
  // }

  componentDidUpdate(prevProps:Props, prevState: State){
    const { advancedSettings } = this.state;
    let updatedAdvancedSettings = {...advancedSettings}
    
    // if(prevProps.packageData !== this.props.packageData){previous Condition Plz check this
      const prevPackageId = _.get(prevProps.packageData, '_id', '');
      const currentPackageId = _.get(this.props.packageData, '_id', '')
      if(!_.isEqual(prevProps.packageData, this.props.packageData) || prevPackageId !== currentPackageId){
      const { packageData } = this.props;
      const generalSettings = getGeneralSetting(packageData)
      const faq = packageData.FAQ;
      const seo = packageData.metatags;
      
      this.handleGeneralSettings(generalSettings);
      if(faq && +faq.length !== 0) {
        this.handleFAQ({FAQ : faq})
      };
      this.handleSEO({metatags: seo});
      this.checkMandatoryFields()
    }


    if(prevProps.generalSettings !== this.props.generalSettings){
      const { generalSettings } = this.props;
      updatedAdvancedSettings = {...updatedAdvancedSettings, ...generalSettings}
      this.setState({
        generalSettings: generalSettings
      }, () => this.checkGeneralSettingsMandatoryFields(this.state.generalSettings))
    }

    if(prevProps.faq !== this.props.faq){
      const { faq, faq: {FAQ} } = this.props;
      let updatedFaq = {...faq};
      let updatedFAQ = [...FAQ];
      updatedFAQ = updatedFAQ.map((faq, index) => {
        return {
          question: faq.question,
          answer: faq.answer,
          sequence: index + 1
        }
      })
      updatedFaq.FAQ = updatedFAQ

      updatedAdvancedSettings = { ...updatedAdvancedSettings, ...updatedFaq}


      this.setState({
        faq: updatedFaq,
      })
    }

    if(prevProps.tabVisited !== this.props.tabVisited){
      const {tabVisited} = this.props;
      const updatedTabvisited = {...tabVisited};
      updatedTabvisited.generalSettings = tabVisited.generalSettings;
      updatedTabvisited.faq = tabVisited.faq;
      updatedTabvisited.seo = tabVisited.seo;
      this.setState({
        tabVisited: updatedTabvisited
      })
    }

    if(prevState.generalSettingsMandatoryFilled !== this.state.generalSettingsMandatoryFilled){
      this.checkMandatoryFields();
    }
    
    if(prevState.seoMandatoryFilled !== this.state.seoMandatoryFilled){
      this.checkMandatoryFields();
    }

    if(prevProps.seo !== this.props.seo){
      const { seo } = this.props;
      updatedAdvancedSettings = { ...updatedAdvancedSettings, ...seo}

      this.setState({
        seo: seo
      }, () => this.checkSeoMandatoryFields(this.state.seo))
    }

  }

  componentWillUnmount = () => {
    this.resetAdvancedSettings()
  }

  handleGeneralSettings = (generalSettings: GeneralSettingsInterface) => {
    // this.setState({
    //   generalSettings: generalSettings,
    // });
    this.props.storeGeneralSettings(generalSettings);
  };

  handleFAQ = (FAQ: FAQInterface) => {

    this.props.storeFAQ(FAQ);
  };

  handleSEO = (SEO: SEOInterface) => {

    this.props.storeSEO(SEO);
  };

  resetAdvancedSettings = () => {

    const generalSettings =  getDefaultGeneralSettings();
    const faq = getDefaultFAQ();
    const seo = getDefaultSEO();


    // Store
    this.props.storeGeneralSettings(generalSettings)
    this.props.storeFAQ(faq)
    this.props.storeSEO(seo)

    //State
    this.setState({
      generalSettings: generalSettings,
      faq: faq,
      seo: seo
    })
  }

  handleAdvancedSettingsSave = () => {
    let advancedSettings = {...this.state.advancedSettings};
    advancedSettings.isPaid = advancedSettings.isPaid === 'Paid' ? true : false;
    advancedSettings.discount = advancedSettings.discount && +advancedSettings.discount;
    advancedSettings.price = advancedSettings.price && +advancedSettings.price;

    this.props.saveAdvancedSettings({
      advancedSettings: advancedSettings,
      packageId: this.state.packageId
    })

  };

  checkFormErrors = (formErrors:any) => {
    //activateSaveSettingsBtn: any error in any of the three tabs, this is false

    let activateSaveSettingsBtn = true;
    if(formErrors.discount && formErrors.discount !== ''){
      activateSaveSettingsBtn = false;
    }
    if(formErrors.price && formErrors.price !== ''){
      activateSaveSettingsBtn = false;
    }
    formErrors.localWisePriceErrors && formErrors.localWisePriceErrors.forEach((localPriceError:string) => {
      if(localPriceError !== ''){
        activateSaveSettingsBtn = false;
      }
    })
    formErrors.localWiseDiscountErrors && formErrors.localWiseDiscountErrors.forEach((localDiscountError: string) => {
      if(localDiscountError !== ''){
        activateSaveSettingsBtn = false;
      }
    })

    // FAQ Form Error Check
    formErrors.FAQ && formErrors.FAQ.forEach((errorText:string) => {
      if(errorText !== ''){
        activateSaveSettingsBtn = false;
      }
    })

    formErrors.AnswerErrors && formErrors.AnswerErrors.forEach((errorText: string) => {
      if(errorText !== ''){
        activateSaveSettingsBtn = false;
      }
    })

    // SEO Form Error Check
    if(formErrors.title && formErrors.title !== ''){
      activateSaveSettingsBtn = false;
    }
    if(formErrors.description && formErrors.description !== ''){
      activateSaveSettingsBtn = false;
    }
    if(formErrors.keywords && formErrors.keywords !== ''){
      activateSaveSettingsBtn = false;
    }
    this.setState({
      canActivateSaveButton: activateSaveSettingsBtn
    }, () => {
      this.props.setAdvancedSettingsValid(activateSaveSettingsBtn)
    }) // Continue...
    // this.props.setAdvancedSettingsValid(activateSaveSettingsBtn)
  }

  checkMandatoryFields = () => {
    const { setAdvancedSettingMandatoryFlag} = this.props;
    // const generalSettingsMandatoryFields = this.checkGeneralSettingsMandatoryFields(generalSettings)
    const generalSettingsMandatoryFields = this.state.generalSettingsMandatoryFilled
    const seoMandatoryFields = this.state.seoMandatoryFilled
    const advancedSettingsMandatoryFieldsFilled = generalSettingsMandatoryFields && seoMandatoryFields;
    setAdvancedSettingMandatoryFlag(
      advancedSettingsMandatoryFieldsFilled
    )
    // this.props.setAdvancedSettingsValid(advancedSettingsMandatoryFieldsFilled)
  }

  checkGeneralSettingsMandatoryFields = (generalSettings: GeneralSettingsInterface) => {
    let allMandatoryFieldsFilled = true;
    const {
      sellsOutsideIndia,
      price,
      localeWisePrice,
      isPaid
    } = generalSettings;

    if(isPaid && isPaid === 'Paid') {
      if(sellsOutsideIndia){
        localeWisePrice && localeWisePrice.forEach((localPrice) => {
          const { price } = localPrice
          if(Number(price) === 0 || price === undefined){
            allMandatoryFieldsFilled = false;
          }
        })
      }
      else {
        if(Number(price) === 0 || price === undefined){
          allMandatoryFieldsFilled = false;
        }
      }
    }
    this.props.setGeneralSettingsMandatoryFlag(allMandatoryFieldsFilled)

    this.setState({
      generalSettingsMandatoryFilled: allMandatoryFieldsFilled
    })
    // return allMandatoryFieldsFilled;
  }

  checkSeoMandatoryFields = (seo: SEOInterface) => {
    let allMandatoryFieldsFilled = true;
    const { metatags } = seo;
    const {title, keywords, description} = metatags;
    if(title === "" || keywords === "" || description ==="") {
      allMandatoryFieldsFilled = false;
    }
    this.props.setSeoMandatoryFlag(allMandatoryFieldsFilled)
    this.setState({
      seoMandatoryFilled: allMandatoryFieldsFilled
    })
    // return allMandatoryFieldsFilled;
  }

  getStyledTabHeading = (eventKey: string, isActive: boolean) => {
    const {classes} = this.props;
    const isMandatory = this.mandatoryTabs.includes(eventKey);
    return <Typography className={classNames(isActive && classes.blueText)}>{eventKey}{isMandatory && <span className={classes.redColor}>*</span>}</Typography>
  }

  renderTabs = () => {

    const { classes, publishBtnClicked } = this.props;
    return (
      <Card className={classNames(classes.height100VH, classes.overflowAuto)}>
        <CardContent>
            <Grid className={classes.inActiveElement}>
              <MyPATTabs defaultSelected="General Settings" customColor="primayColor">
                <MyPATTab eventKey="General Settings" isCustomCSS={true} borderBottom="2px solid #1d7dea" customColor="#1d7dea" renderer={this.getStyledTabHeading}>
                  <Grid container justify="flex-start" className={classes.tabPanel}>
                    <GeneralSettings
                      generalSettings={this.state.generalSettings}
                      handleGeneralSettings={this.handleGeneralSettings}
                      disableFields={this.state.disableFields}
                      checkFormErrors={this.checkFormErrors}
                      isPreview={this.props.isPreview}
                      tabVisited={this.props.tabVisited}
                      setTabVisited={this.props.setTabVisited}
                      isPublishBtnClicked={publishBtnClicked}
                      checkGeneralSettingsMandatoryFields={this.checkGeneralSettingsMandatoryFields}
                    />
                  </Grid>
                </MyPATTab>
                <MyPATTab eventKey="FAQs" isCustomCSS={true} borderBottom="2px solid #1d7dea" customColor="#1d7dea"  renderer={this.getStyledTabHeading}>
                  <Grid container justify="flex-start" className={classes.tabPanel}>
                    <FAQ 
                      faq={this.state.faq} 
                      handleFAQ={this.handleFAQ} 
                      checkFormErrors={this.checkFormErrors}
                      isPreview={this.props.isPreview}
                      disableFields={this.state.disableFields}
                      tabVisited={this.props.tabVisited}
                      setTabVisited={this.props.setTabVisited}
                      isPublishBtnClicked={publishBtnClicked}
                    />
                  </Grid>
                </MyPATTab>
                <MyPATTab eventKey="SEO" isCustomCSS={true} borderBottom="2px solid #1d7dea" customColor="#1d7dea"  renderer={this.getStyledTabHeading}>
                  <Grid container justify="flex-start" className={classes.tabPanel}>
                    <SEO 
                      seo={this.state.seo} 
                      handleSEO={this.handleSEO} 
                      checkFormErrors={this.checkFormErrors}
                      isPreview={this.props.isPreview}
                      disableFields={this.state.disableFields}
                      tabVisited={this.props.tabVisited}
                      setTabVisited={this.props.setTabVisited}
                      isPublishBtnClicked={publishBtnClicked}
                      checkSeoMandatoryFields={this.checkSeoMandatoryFields}
                    />
                  </Grid>
                </MyPATTab>
              </MyPATTabs>
            </Grid>
        </CardContent>
        {/* <DialogFooter 
          htmlElements = {
              <Button
                variant="contained"
                color="primary"
                // className={classes.test}
                type="submit"
                disabled={!this.state.canActivateSaveButton || this.state.disableFields}
                onClick={this.handleAdvancedSettingsSave}
              >
                Save Settings
              </Button>
          }
        /> */}
      </Card>
    );
  };

  render = () => {
    return <>{this.renderTabs()}</>;
  };
}

//treeData: _.get(state, 'courseMangementData.contentManagementData.treeData', {}),

const mapStateToProps = (state: any) => ({
  generalSettings:
    state.courseMangementData.courseManagementReducer.generalSettings,
  faq: state.courseMangementData.courseManagementReducer.faq,
  seo: state.courseMangementData.courseManagementReducer.seo,
  packageId: state.courseMangementData.courseManagementReducer.packageId,
  packageData: state.courseMangementData.contentManagementData.packageData,
  tabVisited: state.courseMangementData.contentManagementData.tabVisited,
  publishBtnClicked: state.courseMangementData.contentManagementData.publishBtnClicked
});

const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      storeGeneralSettings: storeGeneralSettings,
      storeFAQ: storeFAQ,
      storeSEO: storeSEO,
      saveAdvancedSettings: saveAdvancedSettings,
      getCourseDetails: getCourseDetails,
      setAdvancedSettingsValid: contentManagementAction.setAdvancedSettingsValid,
      setAdvancedSettingsUntouched: contentManagementAction.setAdvancedSettingsUntouched,
      setTabVisited: contentManagementAction.setTabVisited,
      setAdvancedSettingMandatoryFlag: contentManagementAction.setAdvancedSettingMandatoryFlag,
      setGeneralSettingsMandatoryFlag: contentManagementAction.setGeneralSettingsMandatoryFlag,
      setSeoMandatoryFlag: contentManagementAction.setSeoMandatoryFlag
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(courseStyles)(withRouter(AdvancedSettings)));
